import angular from 'angular';

angular.module('webTools').directive('wtContextMenu', [
    function() {
        return {
            restrict: 'E',
            replace: true,
            transclude: false,
            templateUrl: "/partials/context-menu.html",
            scope: {
                menuData: '=menuData'
            },
            link: function(scope) {
                scope.launch = function(action, data) {
                    scope.$emit(action, data);
                }
            }
        };
    }
]);